import * as Sentry from '@sentry/browser';
import ProjectConfig from 'ProjectConfig';

const sentryConfig = {
  dsn: 'https://0a452f708ec19379d830f360a5041187@sentry.bilyoner.com/2',
  tunnel: '/tunnel',
  environment: ProjectConfig.environment,
  debug: ProjectConfig.environment !== 'production',
  release: `mobile-web@${ProjectConfig.version}-${ProjectConfig.buildHash}`,
  autoSessionTracking: false,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true
    })
  ],
  maxBreadcrumbs: 50,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    'TypeError: Cancelled',
    /Loading chunk [\d]+ failed/,
    /^NetworkError/,
    /^ChunkLoadError/
  ],
  beforeSend (event, hint) {
    if (event.exception) {
      const error = hint.originalException;
      if (error && error.message && error.message.match(/Loading chunk [\d]+ failed/)) {
        return null;
      }
    }
    
    event.tags = {
      ...event.tags,
      page: window.location.pathname,
      userAgent: navigator.userAgent.split(' ').pop()
    };
    
    event.extra = {
      ...event.extra,
      url: window.location.href,
      timestamp: new Date().toISOString()
    };
    
    const errorMessage = event.exception?.values?.[0]?.value || event.message || '';
    const stackTrace = event.exception?.values?.[0]?.stacktrace?.frames || [];
    const firstFrame = stackTrace[0];
    
    const fingerprint = ['{{ default }}'];
    
    if (firstFrame?.filename?.includes('vendors~main')) {
      fingerprint.push('vendor-error');
    }
    
    if (firstFrame?.filename?.includes('node_modules')) {
      // eslint-disable-next-line no-useless-escape
      const match = firstFrame.filename.match(/node_modules\/([^\/]+)/);
      if (match) {
        fingerprint.push(`vendor-${match[1]}`);
      }
    }
    
    if (event.tags?.errorType === 'API_ERROR') {
      const endpoint = event.tags?.endpoint || 'unknown';
      const statusCode = event.tags?.statusCode || 'unknown';
      fingerprint.push(`api-error-${endpoint}-${statusCode}`);
    }
    
    if (errorMessage.match(/Loading chunk [\d]+ failed/)) {
      fingerprint.push('chunk-load-error');
    }
    
    if (errorMessage.includes('Network')) {
      fingerprint.push('network-error');
    }
    
    event.fingerprint = fingerprint;
    
    return event;
  }
};

export function initSentrySdk () {
  Sentry.init(sentryConfig);
}
